import React from "react";
import Navbar from "./Navbar";
import Notes from "./Notes";

export const Home = () => {
  return (
    <div>
      <Navbar />
      <Notes />
    </div>
  );
};
